import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from "react-router"
import ConflictOfInterestCheckListForm from './conflictOfInterestCheckListForm';
import ConflictOfInterestListForms from './conflictOfInterestListForms';
import SearchTip from '../../common/searchTip';

import './conflictOfInterest.scss';

class ConflictOfInterestSearchForm extends React.Component {

    state = {
        isLoading: false
    }

    render() {
        return (
            <>
                {this.props.type === "check" && <div style={{ marginTop: "1em" }}>
                    <SearchTip windowId={`tips_coi`} getSearchTipsModel={this.getSearchTipsModel} />
                    <div className='card'>
                        <div className='card-body'>
                            <ConflictOfInterestCheckListForm {...this.props} />
                        </div>
                    </div>
                </div>}
                {this.props.type === "client" && <ConflictOfInterestListForms {...this.props} type="client" />}
                {this.props.type === "reference" && <ConflictOfInterestListForms {...this.props} type="reference" />}
            </>
        )
    }

    getSearchTipsModel = () => {
        return {
            title: `${this.props.translate('SearchTips.COI.ControlList.Header')}`,
            bodyHtml: this.props.translate('SearchTips.COI.ControlList.Body'),
            hideExtendedTitle: true
        };
    }
}

export default withRouter(withLocalize(ConflictOfInterestSearchForm));
